module.exports = __webpack_public_path__ + "media/react/assets/goal_setting_submenu-5b62faa65d344f45115f2313cc3e3582.svg";